import { useSelector } from "react-redux";
import clsx from "clsx";
import Shops from "../../components/main/shops";
import styles from "./index.module.scss";
import Breadcrumbs from "../../components/common/breadcrumbs";
import { wrapper } from "/redux";
import { addBreadcrumb } from "/redux/action-creaters/breadcrumbs";
import Redis from "/lib/redis";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import Map from "../../components/main/map";
import EdostMap from "../../components/common/edostMap";
import AllShopsMap from "../../components/common/allShopsMap";
import ContactsInfo from "../../components/common/contactsInfo";
import { sspWrapper } from "../../utils/errors/sspWrapper";
import { setTextCity } from "../../utils";
import { fetchAllShops } from "../../redux/action-creaters/contacts";

export default function ContactsPage({ scripts, isBaltex, isFarkop }) {
  const { content, h1 } = useSelector((state) => state.meta);
  const { host } = useSelector((state) => state.params);
  const { cityName } = useSelector((state) => state.location);
  const { shops = [], domainData } = useSelector((state) => state.contacts);

  const hasDomainShops = shops.length > 0;
  const isRussia = cityName === "Россия";
  const shopsWithPage = shops.filter((shop) => shop.page);
  const showShopsList =
    isFarkop &&
    !isRussia &&
    host !== "nn.farkop.ru" &&
    host !== "kirov.farkop.ru" &&
    host !== "ulyanovsk.farkop.ru" &&
    host !== "petrozavodsk.farkop.ru";

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <div className="container">
        <Breadcrumbs />
        <div className={clsx(isBaltex && styles.Baltex)}>
          <h1>{setTextCity(host, domainData, h1, cityName)}</h1>

          {hasDomainShops ? (
            <Map isShowTitle={false} />
          ) : (
            <>
              <ContactsInfo isBaltex={isBaltex} />
              {isRussia ? (
                <AllShopsMap isBaltex={isBaltex} />
              ) : (
                <EdostMap isBaltex={isBaltex} />
              )}
            </>
          )}
          <br />
          <br />
          {showShopsList && (
            <div>
              <h2>Все магазины и установочные центры</h2>
              {shopsWithPage.length > 0 ? (
                <Shops rows={3} />
              ) : (
                <div>
                  Мы работаем над открытием сервисного центра в г. {cityName},
                  можем предложить отправку товара в Ваш город
                </div>
              )}
            </div>
          )}

          <div className={styles.Requisite}>
            <div
              dangerouslySetInnerHTML={{
                __html: setTextCity(host, domainData, content, cityName),
              }}
            />
          </div>
        </div>
      </div>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ req, query, resolvedUrl }) => {
    store.dispatch(addBreadcrumb({ link: "/contacts/", name: "Контакты" }));
    await store.dispatch(fetchAllShops(Redis));
    return pagesWrapper(
      { pageType: SITE_PAGE_TYPE.contacts },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/contacts/",
    );
  }),
);
